import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

import { store } from "react-notifications-component";

import api from "../../services/api";
import estados from "../../services/estados";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";

import GenericUpper from "../../components/generic-upper";
import Agronomo from "../../components/creas/agronomos";
import Agronomov2 from "../../components/creas/agronomos/indexv2";
import AddCreas from "../../components/creas/creas";
import AcordionCard from "../../components/acordionCard";
import InputV3 from "../../components/input/novo/input_v3";
import SelectV2Multi from "../../components/select/select_v2_multi";
import SignatureTypeCards from "../../components/signatureTypeCards";
import ModalAlert from "../../components/modal/modalGeneric";
import InputSign from "../../components/inputSign";
import ModalPassword from "../../components/modal/modal_password";
import ModalText from "../../components/modal/modalText";

import plus from "../../assets/icons/plus.png";
import mais from "../../assets/Mais.png";
import { IconUploads } from "../../assets/icons/iconUploads";

import * as S from "./stylesAddV2";
import { theme } from "../../styles/theme";
import {
  BodyP,
  H6,
  TaglineM,
  TaglineP,
} from "../../styles/stylesTypography";
import Button from "../../components/button/button_v2";
import Status from "../../components/Status";

export const USER = "@userinfo";

const AddAgronomosV2 = ({ ...props }) => {
  const [title, setTitle] = useState("Dados do Responsável Técnico");
  const [step, setStep] = useState(1);

  const [nome, setNome] = useState("");
  const [cpf, setCpf] = useState("");
  const [align] = useState("center");
  const [email, setEmail] = useState("");
  const [enviar_receita, setEnviarReceita] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [assinaturaEletronica, setAssinaturaEletronica] = useState("");
  const [assinaturaEletronicaPadrao, setAssinaturaEletronicaPadrao] = useState("");
  const [assinaturaDigitalPadrao, setAssinaturaDigitalPadrao] = useState("");
  const [assinaturaDigitalNomePadrao, setAssinaturaDigitalNomePadrao] = useState("");

  const [licenca, setLicenca] = useState("");
  const [estadoLicenca, setEstadoLicenca] = useState("");
  const [numeroLicenca, setNumeroLicenca] = useState("");
  const [filial, setFilial] = useState("");
  const [filiaisOptions, setFiliaisOptions] = useState([]);
  const [selectedMetod, setSelectedMetod] = useState("M");
  const [contractSoftId, setContractSoftId] = useState(0);

  const [idAgronomo, setIdAgronomo] = useState("");
  const [erroLicenca, setErroLicenca] = useState(false);
  const [showDisabledCad, setShowDisabledCad] = useState(false);
  // Plano Basic/Pré-pago: não pode adquirir mais licenças, só fazer upgrade (ERRO-708)
  const [planoSemLicencas, setPlanoSemLicencas] = useState(false);

  const [tiposAssinatura] = useState([
    { value: 'M', label: 'Manual' },
    { value: 'D', label: 'Digital' },
    { value: 'E', label: 'Eletrônica' }
  ]);

  const [status, setStatus] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalText, setShowModalText] = useState(false);
  const [showModalBlock, setShowModalBlock] = useState(false);
  const [file, setFile] = useState([]);
  const [textFile, setTextFile] = useState("");
  const [password, setPassword] = useState("");
  const [isValidate, setIsValidate] = useState(false);
  const [idCertificado, setIdCertificado] = useState("");
  const [creaLoading, setCreaLoading] = useState(false);
  const [assinaturaLoading, setAssinaturaLoading] = useState(false);
  const [currentCertificateFormIndex, setCurrentCertificateFormIndex] = useState(null);
  const [renderInput, setRenderInput] = useState(true);


  const getTiposAssinatura = async (estado) => {
    try {
        const response = await api.get(`/sign/estado/${estado}`);
        const tipos = response.data.data;
        let tipo = []

        if (tipos.manual === true) {
            tipo.push('M');
        }
        if (tipos.digital === true) {
            tipo.push('D');
        }
        if (tipos.eletronica === true) {
            tipo.push('E');
        }
        return tipo;

    } catch (error) {
        return ['M', 'D', 'E']; // fallback
    }
  }

  const [licenseForms, setLicenseForms] = useState([
    {
      id: Date.now(),
      licenca: "",
      estadoLicenca: "",
      numeroLicenca: "",
      filial: "",
      selectedMetod: "M",
      usuario: "",
      senha: "",
      receitaInicial: "",
      assinaturaEletronica: "",
      certificadoDigital: null,
      certificadoDigitalNome: "",
      allowedSignatures: ['M', 'D', 'E'],
      erroLicenca: false,
      erroEstado: false,
      erroNumeroLicenca: false,
      erroFilial: false,
      erroMetodo: false,
      erroUsuario: false,
      erroSenha: false,
      erroReceitaInicial: false,
      isOpen: true,
    },
  ]);

  const [dataCreaCreated, setDataCreaCreated] = useState({});
  const [listCreasCreated, setListCreasCreated] = useState([]);
  const [openCreatedCreaIndex, setOpenCreatedCreaIndex] = useState(null);
  const [updatingCreatedCreaId, setUpdatingCreatedCreaId] = useState(null);

  const [
    showContentAcordionCloseAgronomist,
    setShowContentAcordionCloseAgronomist,
  ] = useState(false);
  const [showContentAcordionCloseCrea, setShowContentAcordionCloseCrea] =
    useState(false);

  useEffect(() => {
    const index = openCreatedCreaIndex;
    if (index === null || index === undefined) return;
    const crea = listCreasCreated[index];
    if (!crea?.id || !crea?.estado) return;
    if (Array.isArray(crea.allowedSignatures) && crea.allowedSignatures.length > 0)
      return;

    (async () => {
      const allowed = await getTiposAssinatura(crea.estado);
      setListCreasCreated((prev) =>
        prev.map((c) => (c?.id === crea.id ? { ...c, allowedSignatures: allowed } : c))
      );
    })();
  }, [openCreatedCreaIndex, listCreasCreated]);

  useEffect(() => {
    if (
      typeof assinaturaEletronicaPadrao !== "string" ||
      !assinaturaEletronicaPadrao.startsWith("data:image")
    ) {
      return;
    }

    setListCreasCreated((prev) => {
      let hasChanges = false;
      const next = prev.map((c) => {
        if ((c?.assinaturaDraft ?? c?.assinatura) !== "E") return c;
        if (c?.assinaturaEletronicaDraft === assinaturaEletronicaPadrao) return c;
        hasChanges = true;
        return { ...c, assinaturaEletronicaDraft: assinaturaEletronicaPadrao };
      });
      return hasChanges ? next : prev;
    });
  }, [assinaturaEletronicaPadrao]);

  useEffect(() => {
    if (
      typeof assinaturaDigitalPadrao !== "string" ||
      !assinaturaDigitalPadrao.startsWith("data:")
    ) {
      return;
    }

    setListCreasCreated((prev) => {
      let hasChanges = false;
      const next = prev.map((c) => {
        if ((c?.assinaturaDraft ?? c?.assinatura) !== "D") return c;
        if (c?.certificadoDigitalDraft === assinaturaDigitalPadrao) return c;
        hasChanges = true;
        return {
          ...c,
          certificadoDigitalDraft: assinaturaDigitalPadrao,
          certificadoDigitalNomeDraft:
            c?.certificadoDigitalNomeDraft ||
            assinaturaDigitalNomePadrao ||
            "certificado_digital.pfx",
        };
      });
      return hasChanges ? next : prev;
    });
  }, [assinaturaDigitalNomePadrao, assinaturaDigitalPadrao]);

  const toggleLicenseForm = (index) => {
    const newForms = licenseForms.map((form, i) => {
      if (i === index) {
        return { ...form, isOpen: !form.isOpen };
      }
      return { ...form, isOpen: false }; // Fecha os outros
    });
    setLicenseForms(newForms);
  };

  const updateLicenseForm = (index, field, value) => {
    const newForms = [...licenseForms];
    newForms[index][field] = value;
    setLicenseForms(newForms);
  };

  const getCertificadoDigitalNome = (source) => {
    const possibleNames = [
      source?.certificadoDigitalNomeDraft,
      source?.certificadoDigitalNome,
      source?.certificado_digital_nome,
      source?.certificadoDigitalArquivoNome,
      source?.arquivo_certificado,
      source?.arquivo,
      assinaturaDigitalNomePadrao,
    ];
    return (
      possibleNames.find(
        (name) => typeof name === "string" && name.trim().length > 0
      ) || ""
    );
  };

  const clearAssinaturaDigitalCompartilhada = () => {
    setAssinaturaDigitalPadrao("");
    setAssinaturaDigitalNomePadrao("");
    setLicenseForms((prev) =>
      prev.map((form) =>
        form?.selectedMetod === "D"
          ? {
              ...form,
              certificadoDigital: null,
              certificadoDigitalNome: "",
            }
          : form
      )
    );
    setListCreasCreated((prev) =>
      prev.map((c) =>
        (c?.assinaturaDraft ?? c?.assinatura) === "D"
          ? {
              ...c,
              certificadoDigitalDraft: null,
              certificadoDigitalNomeDraft: "",
            }
          : c
      )
    );
  };

  const validaCertificado = async (certificadoFile, certificadoPassword) => {
    setAssinaturaLoading(true)
    if (cpf) {
      if (certificadoFile && !isValidate && certificadoPassword) {
        const payload = {
          certificado: certificadoFile,
          cpf: cpf,
          senha: certificadoPassword,
        };
        try {
          let user = JSON.parse(localStorage.getItem(USER));
          if (user?.contrato?.agro_plan_functions) {
            let isBlock = false;

            user.contrato.agro_plan_functions.map((e) => {
              if (e.agro_plans_function.id === 9) {
                if (e.status === 0) {
                  isBlock = true;
                }
              }
            });

            if (isBlock === true) {
              closeModalPassword();
              store.addNotification({
                title: "Erro!",
                message: `A função de assinatura digital não está liberada para seu plano!`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 4000,
                  onScreen: true,
                },
              });
            } else {
              const response = await api.post(`/sign/digital`, payload);
              if (response) {
                setIsValidate(true);
                if (response?.data?.data?.id) {
                  setIdCertificado(response.data.data.id);
                }
              }
              setAssinaturaLoading(false)
              store.addNotification({
                title: "Sucesso!",
                message: `${response.data.data.msg}`,
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 4000,
                  onScreen: true,
                },
              });
            }
          }
        } catch (error) {
          setAssinaturaLoading(false)
          closeModalPassword();
          store.addNotification({
            title: "Erro!",
            message: identifyErrorMenssage(error, "ERRO-607 Erro ao validar o certificado digital - Tente novamente, se o erro persistir acione o suporte."),
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 4000,
              onScreen: true,
            },
          });
        }
      }
    } else {
      store.addNotification({
        title: "Erro!",
        message: `Informe o CPF!`,
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
    }
  };

  const onChangeCertificate = (e, index) => {
        let user = JSON.parse(localStorage.getItem(USER));

        if (user?.contract_software_id === 6) {
            setShowModalBlock(true);
        } else {
            let cont = e.target.files.length;
            cont = cont - 1;

            if (e.target.files) {
                if (e.target.files.length > 1) {
                    store.addNotification({
                        title: "Erro!",
                        message: `Não é possível enviar mais que um arquivo!`,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                    return;
                }
                if (
                    e.target.files[cont].type === "application/x-pkcs12"
                ) {
                    let fil = e.target.files;
                    let reader = new FileReader();
                    reader.readAsDataURL(fil[0]);

                    reader.onload = (event) => {
                        setFile(event.target.result);
                        setTextFile(event.target.result);
                        setCurrentCertificateFormIndex(index);
                        updateLicenseForm(index, "certificadoDigital", event.target.result);

                        if (cpf) {
                            updateLicenseForm(index, "certificadoDigitalNome", e.target.files[cont].name);
                            setAssinaturaDigitalNomePadrao(e.target.files[cont].name);
                            setShowModal(true);
                        } else {
                            store.addNotification({
                                title: "Erro!",
                                message: `Informe o CPF!`,
                                type: "danger",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 4000,
                                    onScreen: true
                                }
                            });
                        }
                    };

                } else {
                    store.addNotification({
                        title: "Erro!",
                        message: `O arquivo selecionado não possui a extensão correta`,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                }
            } else {
                store.addNotification({
                    title: "Erro!",
                    message: `Não é possível enviar mais que um arquivo!`,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        }
      };

  const deleteCertificate = async () => {
    setAssinaturaLoading(true)
    try {
        if (idCertificado) {
            const response = await api.delete(`/sign/delete/${idCertificado}`);
            setIdCertificado('');
            store.addNotification({
                title: "Sucesso!",
                message: `${response.data.data}`,
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    } catch (error) {
        store.addNotification({
            title: "Erro!",
            message: identifyErrorMenssage(error, "ERRO-608 Erro ao remover o certificado digital - Tente novamente, se o erro persistir acione o suporte."),
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 4000,
                onScreen: true
            }
        });
    } finally {
      setAssinaturaLoading(false)
    }
  };

  const deleteFile = async (index = currentCertificateFormIndex) => {
      const form = index !== null && index !== undefined ? licenseForms[index] : null;
      const shouldClearAssinaturaAgronomo =
        !!idAgronomo &&
        ((typeof form?.certificadoDigital === "string" &&
          form.certificadoDigital.startsWith("data:")) ||
          (typeof assinaturaDigitalPadrao === "string" &&
            assinaturaDigitalPadrao.startsWith("data:")));

      await deleteCertificate();
      if (index !== null && index !== undefined) {
        updateLicenseForm(index, "certificadoDigital", null);
        updateLicenseForm(index, "certificadoDigitalNome", "");
      }
      if (shouldClearAssinaturaAgronomo) {
        const updated = await handlePutAgronomo(idAgronomo, {
          assinatura: "",
          certificadoDigitalNome: "",
        });
        if (!updated) return;
      } else {
        clearAssinaturaDigitalCompartilhada();
      }
      setIsValidate(false);
      setFile([]);
      setTextFile('');
  };

  const closeModalPassword = () => {
      setRenderInput(false);
      setShowModal(false);
      setPassword('');
      if (currentCertificateFormIndex !== null) {
        updateLicenseForm(currentCertificateFormIndex, "certificadoDigital", null);
        updateLicenseForm(currentCertificateFormIndex, "certificadoDigitalNome", "");
      }
      setTextFile('');
      setIsValidate(false);
  };

  const updatePassword = (value) => {
      setPassword(value);
      validaCertificado(file, value);
      setShowModal(false);
  };

  const openModalText = () => {
    setShowModalText(true);
  };

  const validateFields = (index) => {
    let isValid = true;
    const form = licenseForms[index];
    const newForms = [...licenseForms];

    if (!form.licenca?.value) {
      newForms[index].erroLicenca = true;
      isValid = false;
    }

    if (!form.estadoLicenca?.value) {
      newForms[index].erroEstado = true;
      isValid = false;
    }

    if (!form.numeroLicenca) {
      newForms[index].erroNumeroLicenca = true;
      isValid = false;
    }

    if (!form.filial?.value) {
      newForms[index].erroFilial = true;
      isValid = false;
    }

    if (!form.selectedMetod) {
      newForms[index].erroMetodo = true;
      isValid = false;
    }

    if ((form.estadoLicenca?.value === "SC" || form.estadoLicenca?.value === "ES") && contractSoftId !== 6) {
        if (!form.usuario) {
            newForms[index].erroUsuario = true;
            isValid = false;
        }
        if (!form.senha) {
            newForms[index].erroSenha = true;
            isValid = false;
        }
    }

    if (form.estadoLicenca?.value === "RJ") {
        if (!form.receitaInicial) {
            newForms[index].erroReceitaInicial = true;
            isValid = false;
        }
    }

    setLicenseForms(newForms);

    if (!isValid) {
      store.addNotification({
        title: "Erro",
        message: "Preencha todos os campos obrigatórios",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
    }

    return isValid;
  };

  const getAssinaturaPayloadAgronomo = (index) => {
    const form = licenseForms[index];
    if (
      form?.selectedMetod === "D" &&
      typeof form?.certificadoDigital === "string" &&
      form.certificadoDigital.startsWith("data:")
    ) {
      return form.certificadoDigital;
    }
    if (
      form?.selectedMetod === "E" &&
      typeof form?.assinaturaEletronica === "string" &&
      form.assinaturaEletronica.startsWith("data:image")
    ) {
      return form.assinaturaEletronica;
    }
    return "";
  };

  const getMetodoAssinaturaFromForm = (form) => {
    if (typeof form?.selectedMetod === "string" && form.selectedMetod.length > 0) {
      return form.selectedMetod[0];
    }
    return "";
  };

  const handlePostAgronomo = async (e, index) => {
    setCreaLoading(true)
    try {
      const payload = {
        nome: nome,
        cpf: cpf,
        email: email,
        enviar_receita: enviar_receita ? 1 : 0,
        whatsapp: whatsapp,
        assinatura: getAssinaturaPayloadAgronomo(index),
      };

      const response = await api.post(`/agronomos`, payload);

      if (response) {
        store.addNotification({
          title: "Sucesso",
          message: "Responsável técnico cadastrado com sucesso",
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
        setIdAgronomo(response.data.data.id);
        return response.data.data.id;
      }
    } catch (e) {
       store.addNotification({
          title: "Erro!",
          message: identifyErrorMenssage(e, "ERRO-609 Houve um problema para cadastrar o responsavel tecnico - Tente novamente, se o erro persistir acione o suporte."),
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
    } finally {
      setCreaLoading(false)
    }
  };

  const buildCreaPayloadFromForm = (form, nextStatus) => {
    return {
      estado: form.estadoLicenca.value,
      homologar_automatico:
        (form.estadoLicenca.value === "MT" ||
          form.estadoLicenca.value === "SC" ||
          form.estadoLicenca.value === "ES" ||
          form.estadoLicenca.value === "GO" ||
          form.estadoLicenca.value === "DF" ||
          form.estadoLicenca.value === "NACIONAL") &&
        contractSoftId !== 6
          ? 1
          : 0,
      crea: form.numeroLicenca,
      tipo: form.licenca.value,
      status: nextStatus,
      receita_inicial: form.receitaInicial || "",
      receitas_emitidas: "",
      filial: form.filial.value,
      assinatura: getMetodoAssinaturaFromForm(form),
      usuario: form.usuario || "",
      senha: form.senha || "",
    };
  };

  const handlePostCrea = async (e, id, index) => {
    setCreaLoading(true)
    try {
      const form = licenseForms[index];
      const payload = buildCreaPayloadFromForm(form, 1);

      const response = await api.post(`/agronomos/${id}/creas`, payload);

      if (response.status === 201) {
        let assinaturaEletronicaNova = "";
        if (
          form.selectedMetod === "E" &&
          typeof form.assinaturaEletronica === "string" &&
          form.assinaturaEletronica.startsWith("data:image")
        ) {
          assinaturaEletronicaNova = form.assinaturaEletronica;
          const assinaturaEletronicaAtual =
            assinaturaEletronicaPadrao || assinaturaEletronica || "";
          const assinaturaFoiAlterada =
            assinaturaEletronicaNova !== assinaturaEletronicaAtual;

          if (assinaturaFoiAlterada && id) {
            await handlePutAgronomo(id, {
              assinatura: assinaturaEletronicaNova,
            });
          }

          setAssinaturaEletronica(assinaturaEletronicaNova);
          setAssinaturaEletronicaPadrao(assinaturaEletronicaNova);
        }

        if (
          form.selectedMetod === "D" &&
          typeof form.certificadoDigital === "string" &&
          form.certificadoDigital.startsWith("data:")
        ) {
          const assinaturaDigitalAtual = assinaturaDigitalPadrao || "";
          const assinaturaDigitalFoiAlterada =
            form.certificadoDigital !== assinaturaDigitalAtual;

          if (assinaturaDigitalFoiAlterada && id) {
            await handlePutAgronomo(id, {
              assinatura: form.certificadoDigital,
              certificadoDigitalNome: form.certificadoDigitalNome,
            });
          }

          setAssinaturaDigitalPadrao(form.certificadoDigital);
          if (
            typeof form.certificadoDigitalNome === "string" &&
            form.certificadoDigitalNome.trim().length > 0
          ) {
            setAssinaturaDigitalNomePadrao(form.certificadoDigitalNome);
          }
        }

        if (form.usuario && form.senha) {
             if (form.estadoLicenca.value === 'ES') {
                 await api.post(`/agronomos/usuario/${id}/ES`, {
                     usuario: form.usuario,
                     senha: form.senha
                 });
             }
             if (form.estadoLicenca.value === 'SC') {
                 await api.post(`/agronomos/usuario/${id}/SC`, {
                     usuario: form.usuario,
                     senha: form.senha
                 });
             }
         }

        setListCreasCreated((prev) => [
          ...prev,
          {
            ...response.data.data,
            payloadSnapshot: payload,
            allowedSignatures: form.allowedSignatures,
            assinaturaEletronicaDraft:
              form.selectedMetod === "E" ? form.assinaturaEletronica || "" : "",
            certificadoDigitalDraft:
              form.selectedMetod === "D" ? form.certificadoDigital || null : null,
            certificadoDigitalNomeDraft:
              form.selectedMetod === "D"
                ? form.certificadoDigitalNome ||
                  getCertificadoDigitalNome(response?.data?.data) ||
                  assinaturaDigitalNomePadrao ||
                  "certificado_digital.pfx"
                : "",
          },
        ]);
        setOpenCreatedCreaIndex(null);

        setShowContentAcordionCloseCrea(true);
        setStatus(true);
        store.addNotification({
          title: "Sucesso",
          message: "Crea cadastrado com sucesso",
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });

        // Remove the saved form from the list
        const newForms = licenseForms.filter((_, i) => i !== index);
        setLicenseForms(newForms);

        setStep(0);
      }
    } catch (e) {
      const errorMessage = identifyErrorMenssage(
        e,
        "Houve um problema para cadastrar o CREA/Visto/CFTA"
      );
      const errorsValue = e?.response?.data?.errors;
      const rawErrorMessage =
        typeof errorsValue === "string"
          ? errorsValue
          : typeof e?.response?.data?.message === "string"
          ? e.response.data.message
          : errorMessage;

      if (e.response && e.response.status === 422) {
        setErroLicenca(true);
      }

      if (JSON.stringify(e?.response?.data || "").includes("ERRO-708")) {
        setPlanoSemLicencas(true);
        setShowDisabledCad(true);
      } else if (
        /limite/i.test(rawErrorMessage || "") &&
        /licen[cç]as?/i.test(rawErrorMessage || "")
      ) {
        setShowDisabledCad(true);
      } else {
        store.addNotification({
          title: "Erro",
          message: identifyErrorMenssage(e, "ERRO-610 Houve um problema para cadastrar o CREA/Visto/CFTA - Tente novamente, se o erro persistir acione o suporte."),
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
      }
    } finally {
      setCreaLoading(false)
    }
  };

  const handleCreateAgronomistAndCrea = async (e, index) => {
    if (!validateFields(index)) return;

    try {
      if (idAgronomo) {
        await handlePostCrea(e, idAgronomo, index);
      } else {
        setStep(0);
        const id = await handlePostAgronomo(e,index);
        if (id) {
          await handlePostCrea(e, id, index);
        }
      }
    } catch (e) {
    } finally {
    }
  };

  const updateAgronomoInfo = async (
    nome,
    cpf,
    email,
    enviar,
    whatsapp,
    sendWhatsapp
  ) => {
    setNome(nome);
    setCpf(cpf);
    setEmail(email);
    setEnviarReceita(enviar);
    setWhatsapp(whatsapp);
  };

  const handlePutAgronomo = async (id, data) => {
    try {
      const enviarReceitaRaw = data?.enviar_receita ?? enviar_receita;
      const enviarReceitaPayload =
        enviarReceitaRaw === 1 ||
        enviarReceitaRaw === "1" ||
        enviarReceitaRaw === true ||
        enviarReceitaRaw === "true"
          ? 1
          : 0;

      const assinaturaFromForms =
        licenseForms.find(
          (form) =>
            form?.selectedMetod === "E" &&
            typeof form?.assinaturaEletronica === "string" &&
            form.assinaturaEletronica.startsWith("data:image")
        )?.assinaturaEletronica || "";
      const assinaturaDigitalFromForms =
        licenseForms.find(
          (form) =>
            form?.selectedMetod === "D" &&
            typeof form?.certificadoDigital === "string" &&
            form.certificadoDigital.startsWith("data:")
        )?.certificadoDigital || "";

      const assinaturaPayload =
        data &&
        typeof data.assinatura === "string" &&
        (data.assinatura === "" || data.assinatura.startsWith("data:"))
          ? data.assinatura
          : assinaturaDigitalFromForms ||
            (typeof assinaturaDigitalPadrao === "string" &&
            assinaturaDigitalPadrao.startsWith("data:")
              ? assinaturaDigitalPadrao
              : "") ||
            assinaturaFromForms ||
            (typeof assinaturaEletronica === "string" &&
            assinaturaEletronica.startsWith("data:image")
              ? assinaturaEletronica
              : "");

      const payload = {
        nome: data?.nome ?? nome,
        cpf: data?.cpf ?? cpf,
        email: data?.email ?? email,
        enviar_receita: enviarReceitaPayload,
        whatsapp: data?.whatsapp ?? whatsapp,
        assinatura: assinaturaPayload,
      };

      const response = await api.put(`/agronomos/${id}`, payload);

      if (response.status === 200) {
        if (
          typeof assinaturaPayload === "string" &&
          assinaturaPayload.startsWith("data:image")
        ) {
          setAssinaturaEletronica(assinaturaPayload);
          setAssinaturaEletronicaPadrao(assinaturaPayload);
        } else if (
          typeof assinaturaPayload === "string" &&
          assinaturaPayload.startsWith("data:")
        ) {
          setAssinaturaDigitalPadrao(assinaturaPayload);
          if (
            typeof data?.certificadoDigitalNome === "string" &&
            data.certificadoDigitalNome.trim().length > 0
          ) {
            setAssinaturaDigitalNomePadrao(data.certificadoDigitalNome);
          }
        } else if (assinaturaPayload === "") {
          clearAssinaturaDigitalCompartilhada();
        }
        store.addNotification({
          title: "Sucesso",
          message: "Responsável técnico atualizado com sucesso",
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
        return true;
      }
    } catch (e) {
      store.addNotification({
        title: "Erro",
        message: identifyErrorMenssage(
          e,
          "ERRO-611 Nao foi possivel atualizar o responsavel tecnico - Tente novamente, se o erro persistir acione o suporte."
        ),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
      return false;
    }
  };

  const updateCreatedCreaStatus = async (creaItemOrId, newStatus, newAssinatura) => {
    const creaId =
      typeof creaItemOrId === "object" ? creaItemOrId?.id : creaItemOrId;
    const snapshot =
      typeof creaItemOrId === "object" ? creaItemOrId?.payloadSnapshot : null;

    try {
      setCreaLoading(true)
      setUpdatingCreatedCreaId(creaId);

      if (snapshot && creaId) {
        const response = await api.put(`/creas/${creaId}`, {
          ...snapshot,
          receita_inicial: snapshot?.receita_inicial === "" ? 0 : snapshot?.receita_inicial,
          status: newStatus,
          assinatura: newAssinatura ?? snapshot?.assinatura,
        });
        if (response?.status === 200) {
          store.addNotification({
            title: "Sucesso",
            message: "CREA/Visto/CFTA atualizado com sucesso",
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });
          return true;
        }
      }

      const responseCrea = await api.get(`/creas/${creaId}`);
      const current = responseCrea?.data?.data;

      const payload = {
        estado: current?.estado,
        crea: current?.crea,
        tipo: current?.tipo,
        filial:
          current?.filial?.id ??
          current?.filial ??
          current?.agronomo?.filial?.id ??
          current?.agronomo?.filial?.nome_fantasia,
        agro_agronomist_id: current?.agronomo?.id ?? current?.agro_agronomist_id,
        receita_inicial: current?.receita_inicial === "" ? 0 : current?.receita_inicial,
        receitas_emitidas: current?.receitas_emitidas ?? 0,
        status: newStatus,
        assinatura: newAssinatura ?? current?.assinatura,
        homologar_automatico: current?.homologar_automatico,
        usuario: current?.usuario ?? "",
        senha: current?.senha ?? "",
      };

      const response = await api.put(`/creas/${creaId}`, payload);
      if (response?.status === 200) {
        store.addNotification({
          title: "Sucesso",
          message: "CREA/Visto/CFTA atualizado com sucesso",
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
        return true;
      }
      return false;
    } catch (e) {
      store.addNotification({
        title: "Erro",
        message: identifyErrorMenssage(
          e,
          "ERRO-612 Nao foi possivel atualizar o status da licenca - Tente novamente, se o erro persistir acione o suporte."
        ),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
      return false;
    } finally {
      setCreaLoading(false)
      setUpdatingCreatedCreaId(null);
    }
  };

  const getFiliais = async () => {
    try {
      const response = await api.get(`/filiais`);
      const filiais = response.data.data;

      if (filiais.length) {
        const formatFiliais = filiais.map((f) => {
          let format = {
            value: f.id,
            label: f.nome_fantasia,
          };
          return format;
        });

        if (filiais && filiais.length > 0) {
          setFiliaisOptions(formatFiliais);
        } else {
          setFiliaisOptions(formatFiliais);
        }
      } else {
        const formatFiliais = [
          { value: filiais.id, label: filiais.nome_fantasia },
        ];
        setFiliaisOptions(formatFiliais);
      }
    } catch (e) {}
  };

  const loadAssinaturaAgronomo = async (agronomoIdParam) => {
    if (!agronomoIdParam) return;
    try {
      const response = await api.get(`/agronomos/${agronomoIdParam}`);
      const agronomoData = response?.data?.data || {};
      const assinatura = agronomoData?.assinatura;
      const nomeCertificadoSalvo = getCertificadoDigitalNome(agronomoData);
      if (typeof assinatura === "string" && assinatura.startsWith("data:image")) {
        setAssinaturaEletronica(assinatura);
        setAssinaturaEletronicaPadrao(assinatura);
        setAssinaturaDigitalPadrao("");
        setAssinaturaDigitalNomePadrao("");

        setLicenseForms((prev) =>
          prev.map((form) => {
            const hasDataInForm =
              !!form?.licenca ||
              !!form?.estadoLicenca ||
              !!form?.numeroLicenca ||
              !!form?.certificadoDigital ||
              !!form?.assinaturaEletronica;
            const allowsEletronic =
              !Array.isArray(form?.allowedSignatures) ||
              form.allowedSignatures.length === 0 ||
              form.allowedSignatures.includes("E");

            if (hasDataInForm || !allowsEletronic) return form;

            return {
              ...form,
              selectedMetod: "E",
              assinaturaEletronica: assinatura,
              erroMetodo: false,
            };
          })
        );
      } else if (typeof assinatura === "string" && assinatura.startsWith("data:")) {
        setAssinaturaDigitalPadrao(assinatura);
        if (nomeCertificadoSalvo) {
          setAssinaturaDigitalNomePadrao(nomeCertificadoSalvo);
        }

        setLicenseForms((prev) =>
          prev.map((form) => {
            const hasDataInForm =
              !!form?.licenca ||
              !!form?.estadoLicenca ||
              !!form?.numeroLicenca ||
              !!form?.certificadoDigital ||
              !!form?.assinaturaEletronica;
            const allowsDigital =
              !Array.isArray(form?.allowedSignatures) ||
              form.allowedSignatures.length === 0 ||
              form.allowedSignatures.includes("D");

            if (hasDataInForm || !allowsDigital) return form;

            return {
              ...form,
              selectedMetod: "D",
              certificadoDigital: assinatura,
              certificadoDigitalNome:
                nomeCertificadoSalvo ||
                assinaturaDigitalNomePadrao ||
                "certificado_digital.pfx",
              erroMetodo: false,
            };
          })
        );
      }
    } catch (e) {
    }
  };

  useEffect(() => {
    getFiliais();

    let user = JSON.parse(localStorage.getItem(USER));
    if (user.contrato.agro_plan_config.is_teste === 0) {
      setContractSoftId(8);
    } else {
      setContractSoftId(6);
    }

    const validaLimite = async () => {
      try {
        await api.get("/agronomos/limite");
      } catch (error) {
        setPlanoSemLicencas(JSON.stringify(error?.response?.data || "").includes("ERRO-708"));
        setShowDisabledCad(true);
      }
    };

    validaLimite();
  }, []);

  useEffect(() => {
    if (filiaisOptions.length !== 1) return;
    const onlyOption = filiaisOptions[0];

    setLicenseForms((prev) =>
      prev.map((form) => {
        const hasFilialSelected =
          typeof form?.filial === "object" && !!form?.filial?.value;
        if (hasFilialSelected) return form;
        return { ...form, filial: onlyOption, erroFilial: false };
      })
    );
  }, [filiaisOptions]);

  useEffect(() => {
    if (props.estado) {
      setEstadoLicenca(props.estado);
    }
  }, [props.estado]);


  return (
    <>
      <GenericUpper
        align={align}
        title={title}
        help={true}
        text={"Dúvidas para cadastrar um responsável técnico?"}
        toSearch={"https://agroreceita.com.br/cadastro-responsavel-tecnico/"}
        textToSearch={"Clique aqui e acesse o tutorial!"}
      ></GenericUpper>

      <S.Container>
        <S.Wrapper>
          <AcordionCard
            title={nome ? nome : `Dados do Responsável Técnico`}
            isOpen={step === 1}
            showContentAcordionClose={showContentAcordionCloseAgronomist}
            contentAcordionClose={
              <S.ContainerContentAcordionClose>
                <S.InformationAcordionClose>
                  <TaglineP>E-mail</TaglineP>

                  <BodyP fontWeight={theme.typography.fontWeight.bold}>
                    {email}
                  </BodyP>
                </S.InformationAcordionClose>

                <S.InformationAcordionClose>
                  <TaglineP>CPF</TaglineP>

                  <BodyP fontWeight={theme.typography.fontWeight.bold}>
                    {cpf}
                  </BodyP>
                </S.InformationAcordionClose>

                {whatsapp && (
                  <S.InformationAcordionClose>
                    <TaglineP>Whatsapp</TaglineP>

                    <BodyP fontWeight={theme.typography.fontWeight.bold}>
                      {whatsapp}
                    </BodyP>
                  </S.InformationAcordionClose>
                )}
              </S.ContainerContentAcordionClose>
            }
          >
            <Agronomov2
              nome={nome}
              cpf={cpf}
              email={email}
              enviar_receita={enviar_receita}
              whatsapp={whatsapp}
              agronomoId={idAgronomo}
              assinatura={selectedMetod}
              assinaturaEletronica={assinaturaEletronica}
              hideAssinaturaSelector={true}
              onSave={
                idAgronomo
                  ? async (data) => {
                      return await handlePutAgronomo(idAgronomo, data);
                    }
                  : undefined
              }
              update={updateAgronomoInfo}
              next={() => {
                setShowContentAcordionCloseAgronomist(true);
                setStep((prev) => (prev === 1 ? 2 : prev));
              }}
              propsLocation={props}
              isModal={props.isModal}
            />
          </AcordionCard>

          {listCreasCreated.map((crea, index) => (
            <AcordionCard
              key={index}
              title={
                crea?.tipo === "crea"
                  ? `CREA: ${crea.crea}`
                  : crea?.tipo === "visto"
                  ? `VISTO: ${crea.crea}`
                  : crea?.tipo === "cfta"
                  ? `CFTA: ${crea.crea}`
                  : "Licença profissional"
              }
              isOpen={openCreatedCreaIndex === index}
              height={true}
              hasBlock={false}
              accordionKey={index}
              onToggle={(key) => {
                setOpenCreatedCreaIndex((prev) => (prev === key ? null : key));
              }}
              showContentAcordionClose={true}
              contentAcordionClose={
                <S.ContainerContentAcordionClose>
                  <S.InformationAcordionClose>
                    <TaglineP>UF</TaglineP>

                    <BodyP fontWeight={theme.typography.fontWeight.bold}>
                      {estados.find((e) => e.value === crea.estado)?.label ||
                        crea.estado}
                    </BodyP>
                  </S.InformationAcordionClose>

                  <S.InformationAcordionClose>
                    <TaglineP>Assinatura</TaglineP>

                    <BodyP fontWeight={theme.typography.fontWeight.bold}>
                      {(crea?.assinaturaDraft ?? crea.assinatura) === "M"
                        ? "Manual"
                        : (crea?.assinaturaDraft ?? crea.assinatura) === "E"
                        ? "Eletrônico"
                        : "Digital"}
                    </BodyP>
                  </S.InformationAcordionClose>

                  <Status status={crea?.status === 1 ? "AT" : "IN"}></Status>

                  {/* <S.InformationAcordionClose>
                    <TaglineP>Arts ativas</TaglineP>

                    <BodyP fontWeight={theme.typography.fontWeight.bold}>
                      0
                    </BodyP>
                  </S.InformationAcordionClose> */}
                </S.ContainerContentAcordionClose>
              }
            >
              <S.ContainerCpntentAcordionCard>
                <InputV3
                  id={`tipo_${index}`}
                  type="text"
                  floatingLabel="Tipo de licença"
                  value={
                    crea?.tipo === "crea"
                      ? "CREA"
                      : crea?.tipo === "visto"
                      ? "Visto"
                      : crea?.tipo === "cfta"
                      ? "CFTA"
                      : "Licença profissional"
                  }
                  isDisabled={true}
                />

                <InputV3
                  id={`uf_${index}`}
                  type="text"
                  floatingLabel="Estado (UF)"
                  value={
                    estados.find((e) => e.value === crea.estado)?.label ||
                    crea.estado ||
                    ""
                  }
                  isDisabled={true}
                />

                <InputV3
                  id={`numero_${index}`}
                  type="text"
                  floatingLabel="Número do documento"
                  value={crea?.crea || ""}
                  isDisabled={true}
                />

                <InputV3
                  id={`status_${index}`}
                  type="select"
                  floatingLabel="Status"
                  isDisabled={updatingCreatedCreaId === crea?.id}
                  options={[
                    { value: 1, label: "Ativo" },
                    { value: 0, label: "Inativo" },
                  ]}
                  typeValueSelect="number"
                  floatingValue={
                    (crea?.statusDraft ?? crea?.status) === 1 ? "Ativo" : "Inativo"
                  }
                  onChange={(selectedOption) => {
                    const nextStatus =
                      typeof selectedOption?.value === "number"
                        ? selectedOption.value
                        : Number(selectedOption?.value);

                    if (isNaN(nextStatus)) return;
                    setListCreasCreated((prev) =>
                      prev.map((c) =>
                        c?.id === crea.id ? { ...c, statusDraft: nextStatus } : c
                      )
                    );
                  }}
                />

                <SignatureTypeCards
                  value={crea?.assinaturaDraft ?? crea?.assinatura}
                  onChange={(type) => {
                    setListCreasCreated((prev) =>
                      prev.map((c) => {
                        if (c?.id !== crea.id) return c;
                        if (type === "E") {
                          return {
                            ...c,
                            assinaturaDraft: "E",
                            assinaturaEletronicaDraft:
                              c?.assinaturaEletronicaDraft ||
                              assinaturaEletronicaPadrao ||
                              assinaturaEletronica ||
                              "",
                          };
                        }
                        if (type === "D") {
                          return {
                            ...c,
                            assinaturaDraft: "D",
                            certificadoDigitalDraft:
                              c?.certificadoDigitalDraft || assinaturaDigitalPadrao || null,
                            certificadoDigitalNomeDraft:
                              c?.certificadoDigitalNomeDraft ||
                              (assinaturaDigitalPadrao
                                ? assinaturaDigitalNomePadrao || "certificado_digital.pfx"
                                : ""),
                          };
                        }
                        return { ...c, assinaturaDraft: "M" };
                      })
                    );
                  }}
                  allowedSignatures={crea?.allowedSignatures}
                  estadoValue={crea?.estado}
                  hasElectronicCredential={!!(
                    crea?.assinaturaEletronicaDraft || assinaturaEletronicaPadrao || assinaturaEletronica
                  )}
                  hasDigitalCredential={!!(
                    crea?.certificadoDigitalDraft ||
                    (typeof assinaturaDigitalPadrao === "string" && assinaturaDigitalPadrao.startsWith("data:"))
                  )}
                  namePrefix={`card_radio_assinatura_created_${index}`}
                  responsavelNome={nome}
                />

                {(crea?.assinaturaDraft ?? crea?.assinatura) === "E" ? (
                  <div style={{ width: "100%", marginTop: "20px" }}>
                    <InputSign
                      key={`created-sign-${crea?.id}-${crea?.assinaturaDraft ?? crea?.assinatura}-${(
                        crea?.assinaturaEletronicaDraft ||
                        assinaturaEletronicaPadrao ||
                        assinaturaEletronica ||
                        ""
                      ).length}`}
                      sign={
                        crea?.assinaturaEletronicaDraft ||
                        assinaturaEletronicaPadrao ||
                        assinaturaEletronica ||
                        ""
                      }
                      update={(value) => {
                        setListCreasCreated((prev) =>
                          prev.map((c) =>
                            c?.id === crea.id
                              ? {
                                  ...c,
                                  assinaturaEletronicaDraft: value,
                                }
                              : c
                          )
                        );
                      }}
                    />
                  </div>
                ) : null}

                {(crea?.assinaturaDraft ?? crea?.assinatura) === "D" ? (
                  <div
                    style={{
                      width: "100%",
                      marginTop: "20px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <label
                      style={{
                        paddingLeft: "15px",
                        textAlign: "left",
                        fontSize: "12px",
                        fontWeight: 700,
                        color: "#8a92a2",
                      }}
                    >
                      Upload certificado digital AQ
                    </label>
                    <div className="input-wrapper">
                      <div className="arquivos">
                        <label className="btn-update" htmlFor={`created-input-file-${index}`}>
                          <IconUploads
                            width="auto"
                            height="40px"
                            marginBottom="100px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                          />
                          Selecione o arquivo PFX em seu computador.<br></br><br></br>O upload do certificado é necessário caso deseje assinar sua receita digitalmente.
                          <label className="arq-name">
                            {getCertificadoDigitalNome(crea) ? (
                              <>
                                {getCertificadoDigitalNome(crea)}
                                <img
                                  src={mais}
                                  width="20"
                                  height="20"
                                  onClick={async (event) => {
                                    event.preventDefault();
                                    if (idAgronomo) {
                                      const updated = await handlePutAgronomo(idAgronomo, {
                                        assinatura: "",
                                        certificadoDigitalNome: "",
                                      });
                                      if (!updated) return;
                                    } else {
                                      clearAssinaturaDigitalCompartilhada();
                                    }
                                  }}
                                />
                              </>
                            ) : (
                              "Nenhum arquivo selecionado"
                            )}
                          </label>
                        </label>
                      </div>

                      <input
                        style={{ display: "none" }}
                        type="file"
                        id={`created-input-file-${index}`}
                        name={`created-file-${index}`}
                        onChange={(e) => {
                          const fileSelected = e.target.files?.[0];
                          if (!fileSelected) return;
                          if (fileSelected.type !== "application/x-pkcs12") {
                            store.addNotification({
                              title: "Erro!",
                              message: `O arquivo selecionado não possui a extensão correta`,
                              type: "danger",
                              insert: "top",
                              container: "top-right",
                              animationIn: ["animated", "fadeIn"],
                              animationOut: ["animated", "fadeOut"],
                              dismiss: {
                                duration: 4000,
                                onScreen: true,
                              },
                            });
                            return;
                          }
                          const reader = new FileReader();
                          reader.readAsDataURL(fileSelected);
                          reader.onload = (event) => {
                            const result = event?.target?.result;
                            setAssinaturaDigitalNomePadrao(fileSelected.name);
                            setListCreasCreated((prev) =>
                              prev.map((c) =>
                                c?.id === crea.id
                                  ? {
                                      ...c,
                                      certificadoDigitalDraft: result,
                                      certificadoDigitalNomeDraft: fileSelected.name,
                                    }
                                  : c
                              )
                            );
                          };
                        }}
                      />
                    </div>
                  </div>
                ) : null}

                <Button
                  width="100%"
                  height="50px"
                  value="Salvar CREA/CFTA/VISTO"
                  outline={false}
                  disabled={false}
                  onClick={async () => {
                    if (!crea?.id) return;
                    const nextStatus = crea?.statusDraft ?? crea?.status;
                    const nextAssinatura = crea?.assinaturaDraft ?? crea?.assinatura;
                    let assinaturaEletronicaAtualizada =
                      assinaturaEletronicaPadrao || assinaturaEletronica || "";
                    let shouldSyncAllElectronicSignatures = false;
                    let assinaturaDigitalAtualizada = assinaturaDigitalPadrao || "";
                    let shouldSyncAllDigitalSignatures = false;

                    if (idAgronomo && nextAssinatura === "E") {
                      const assinaturaEletronicaToSave =
                        crea?.assinaturaEletronicaDraft ||
                        assinaturaEletronicaPadrao ||
                        assinaturaEletronica ||
                        "";
                      if (
                        typeof assinaturaEletronicaToSave === "string" &&
                        assinaturaEletronicaToSave.startsWith("data:image")
                      ) {
                        const assinaturaEletronicaAtual =
                          assinaturaEletronicaPadrao || assinaturaEletronica || "";
                        const assinaturaFoiAlterada =
                          assinaturaEletronicaToSave !== assinaturaEletronicaAtual;

                        if (assinaturaFoiAlterada) {
                          const updated = await handlePutAgronomo(idAgronomo, {
                            assinatura: assinaturaEletronicaToSave,
                          });
                          if (!updated) return;
                          setAssinaturaEletronica(assinaturaEletronicaToSave);
                          setAssinaturaEletronicaPadrao(assinaturaEletronicaToSave);
                          setLicenseForms((prev) =>
                            prev.map((form) =>
                              form?.selectedMetod === "E"
                                ? { ...form, assinaturaEletronica: assinaturaEletronicaToSave }
                                : form
                            )
                          );
                          assinaturaEletronicaAtualizada = assinaturaEletronicaToSave;
                          shouldSyncAllElectronicSignatures = true;
                        }
                      }
                    }

                    if (idAgronomo && nextAssinatura === "D") {
                      const certificadoDigitalToSave = crea?.certificadoDigitalDraft;
                      if (
                        typeof certificadoDigitalToSave === "string" &&
                        certificadoDigitalToSave.startsWith("data:")
                      ) {
                        const assinaturaDigitalAtual = assinaturaDigitalPadrao || "";
                        const assinaturaDigitalFoiAlterada =
                          certificadoDigitalToSave !== assinaturaDigitalAtual;

                        if (assinaturaDigitalFoiAlterada) {
                          const updated = await handlePutAgronomo(idAgronomo, {
                            assinatura: certificadoDigitalToSave,
                            certificadoDigitalNome: getCertificadoDigitalNome(crea),
                          });
                          if (!updated) return;
                          setAssinaturaDigitalPadrao(certificadoDigitalToSave);
                          setAssinaturaDigitalNomePadrao(
                            getCertificadoDigitalNome(crea) || assinaturaDigitalNomePadrao
                          );
                          assinaturaDigitalAtualizada = certificadoDigitalToSave;
                          shouldSyncAllDigitalSignatures = true;
                        }
                      }
                    }

                    const ok = await updateCreatedCreaStatus(
                      crea,
                      nextStatus,
                      nextAssinatura
                    );
                    if (!ok) return;

                    setListCreasCreated((prev) =>
                      prev.map((c) =>
                        c?.id === crea.id
                          ? {
                              ...c,
                              status: nextStatus,
                              statusDraft: undefined,
                              assinatura: nextAssinatura,
                              assinaturaDraft: undefined,
                              assinaturaEletronicaDraft:
                                nextAssinatura === "E"
                                  ? c?.assinaturaEletronicaDraft ||
                                    assinaturaEletronicaAtualizada ||
                                    ""
                                  : c?.assinaturaEletronicaDraft,
                              certificadoDigitalDraft:
                                nextAssinatura === "D"
                                  ? c?.certificadoDigitalDraft ||
                                    assinaturaDigitalAtualizada ||
                                    null
                                  : c?.certificadoDigitalDraft,
                              certificadoDigitalNomeDraft:
                                nextAssinatura === "D"
                                  ? c?.certificadoDigitalNomeDraft ||
                                    assinaturaDigitalNomePadrao ||
                                    (assinaturaDigitalAtualizada
                                      ? "certificado_digital.pfx"
                                      : "")
                                  : c?.certificadoDigitalNomeDraft,
                            }
                          : shouldSyncAllElectronicSignatures &&
                            (c?.assinaturaDraft ?? c?.assinatura) === "E"
                          ? {
                              ...c,
                              assinaturaEletronicaDraft: assinaturaEletronicaAtualizada,
                            }
                          : shouldSyncAllDigitalSignatures &&
                            (c?.assinaturaDraft ?? c?.assinatura) === "D"
                          ? {
                              ...c,
                              certificadoDigitalDraft: assinaturaDigitalAtualizada,
                              certificadoDigitalNomeDraft:
                                c?.certificadoDigitalNomeDraft ||
                                assinaturaDigitalNomePadrao ||
                                "certificado_digital.pfx",
                            }
                          : c
                      )
                    );
                  }}
                  loading={assinaturaLoading || creaLoading}
                />
              </S.ContainerCpntentAcordionCard>
            </AcordionCard>
          ))}

          {licenseForms.map((form, index) => (
            <AcordionCard
              key={form.id}
              title={
                form.crea?.tipo === "crea"
                  ? `CREA: ${form.crea.crea}`
                  : form.crea?.tipo === "visto"
                  ? `VISTO: ${form.crea.crea}`
                  : form.crea?.tipo === "cfta"
                  ? `CFTA: ${form.crea.crea}`
                  : "Licença profissional"
              }
              isOpen={form.isOpen && (step !== 1 || !!idAgronomo)}
              height={true}
              hasBlock={step === 1 && !idAgronomo}
              showContentAcordionClose={false}
              onClick={() => toggleLicenseForm(index)}
            >
              <S.ContainerCpntentAcordionCard>
                <InputV3
                  id="licenca"
                  type="select"
                  floatingLabelWithAsterisk="Tipo de licença"
                  value={form.licenca.label}
                  onChange={(selectedOption) => {
                    setErroLicenca(false);

                    updateLicenseForm(index, "licenca", {
                      value: selectedOption.value,
                      label: selectedOption.label,
                    });
                    
                    if(selectedOption.value === 'cfta') {
                         updateLicenseForm(index, "estadoLicenca", { value: "NACIONAL", label: "Nacional" });
                    }

                    updateLicenseForm(index, "erroLicenca", false);
                  }}
                  options={[
                    { value: "crea", label: "CREA" },
                    { value: "visto", label: "Visto" },
                    { value: "cfta", label: "CFTA" },
                  ]}
                  hasError={form.erroLicenca || erroLicenca}
                  errorInfo={""}
                  floatingValue={form.licenca.label}
                />

                <SelectV2Multi
                  height="auto"
                  marginBottom={form.licenca?.value === 'cfta' ? '0px' : '24px'}
                  name="estado"
                  className="select"
                  label="Estado (UF)"
                  labelWithAsterisk={true}
                  id="estado"
                  value={form.estadoLicenca?.value || form.estadoLicenca || ""}
                  disabled={form.licenca?.value === 'cfta'}
                  loading={false}
                  erro={form.erroEstado}
                  messageErro={""}
                  onChange={async (selectedOption) => {
                    updateLicenseForm(index, "estadoLicenca", selectedOption);
                    
                    if(selectedOption.value === 'NACIONAL') {
                         updateLicenseForm(index, "licenca", { value: "cfta", label: "CFTA" });
                    }
                    
                    if(selectedOption.value) {
                        const allowed = await getTiposAssinatura(selectedOption.value);
                        updateLicenseForm(index, "allowedSignatures", allowed);
                        
                        // Se a assinatura selecionada não for permitida, reseta para manual ou a primeira permitida
                        const form = licenseForms[index];
                        if (!allowed.includes(form.selectedMetod)) {
                             updateLicenseForm(index, "selectedMetod", allowed.includes('M') ? 'M' : allowed[0]);
                        }
                    } else {
                        // Se limpar o estado, permite todas
                        updateLicenseForm(index, "allowedSignatures", ['M', 'D', 'E']);
                    }

                    updateLicenseForm(index, "erroEstado", false);
                  }}
                  options={[...estados, { value: "NACIONAL", label: "Nacional" }]}
                  selectUniqueOption={true}
                  buttonAddNew={false}
                  isModal={true}
                  isClearable={true}
                  labelColor="#8A92A2"
                  labelMarginLeft="14px"
                  inputColor="#21262F"
                  InputFontSize="14px"
                  InputFontWeight="400"
                  InputPadding="13px 65px 12px 14px"
                  colorBorder="solid 1px #8A92A2"
                />

                <InputV3
                  id="licenca"
                  type="text"
                  floatingLabelWithAsterisk="Número do documento"
                  value={form.numeroLicenca}
                  onChange={(e) => {
                    updateLicenseForm(index, "numeroLicenca", e.target.value);
                    updateLicenseForm(index, "erroNumeroLicenca", false);
                  }}
                  hasError={form.erroNumeroLicenca}
                  errorInfo={""}
                  floatingValue={form.numeroLicenca}
                  handleClear={() => {
                    updateLicenseForm(index, "numeroLicenca", "");
                  }}
                />

                {form.estadoLicenca?.value === "RJ" && (
                    <InputV3
                        id="receita_inicial"
                        type="text"
                        floatingLabelWithAsterisk="Receita Inicial"
                        value={form.receitaInicial}
                        onChange={(e) => {
                            updateLicenseForm(index, "receitaInicial", e.target.value);
                            updateLicenseForm(index, "erroReceitaInicial", false);
                        }}
                        hasError={form.erroReceitaInicial}
                        errorInfo={""}
                        floatingValue={form.receitaInicial}
                    />
                )}

                {(form.estadoLicenca?.value === "SC" || form.estadoLicenca === "SC") ? (
                    <>
                        <InputV3
                            id="user"
                            type="text"
                            floatingLabelWithAsterisk="Usuário SIGEN"
                            value={form.usuario}
                            onChange={(e) => {
                                updateLicenseForm(index, "usuario", e.target.value);
                                updateLicenseForm(index, "erroUsuario", false);
                            }}
                            hasError={form.erroUsuario}
                            errorInfo={""}
                            floatingValue={form.usuario}
                        />

                        <div className="senha" style={{ width: "100%" }}>
                            <InputV3
                                id="pass"
                                type="password"
                                floatingLabelWithAsterisk="Senha SIGEN"
                                value={form.senha}
                                onChange={(e) => {
                                    updateLicenseForm(index, "senha", e.target.value);
                                    updateLicenseForm(index, "erroSenha", false);
                                }}
                                hasError={form.erroSenha}
                                errorInfo={""}
                                floatingValue={form.senha}
                            />
                        </div>
                    </>
                ) : (<>
                    {(form.estadoLicenca?.value === "ES" || form.estadoLicenca === "ES") && contractSoftId != 6 ? (
                        <>
                            <InputV3
                                id="user"
                                type="text"
                                floatingLabelWithAsterisk="Usuário IDAF"
                                value={form.usuario}
                                onChange={(e) => {
                                    updateLicenseForm(index, "usuario", e.target.value);
                                    updateLicenseForm(index, "erroUsuario", false);
                                }}
                                hasError={form.erroUsuario}
                                errorInfo={""}
                                floatingValue={form.usuario}
                            />

                            <InputV3
                                id="pass"
                                type="password"
                                floatingLabelWithAsterisk="Senha IDAF"
                                value={form.senha}
                                onChange={(e) => {
                                    updateLicenseForm(index, "senha", e.target.value);
                                    updateLicenseForm(index, "erroSenha", false);
                                }}
                                hasError={form.erroSenha}
                                errorInfo={""}
                                floatingValue={form.senha}
                            />
                        </>
                    ) : (
                        null
                    )}
                </>)}

                <InputV3
                  id="filial"
                  type="select"
                  typeValueSelect="number"
                  floatingLabelWithAsterisk="Filial"
                  value={form.filial.label}
                  onChange={(selectedOption) => {
                    updateLicenseForm(index, "filial", {
                      value: selectedOption.value,
                      label: selectedOption.label,
                    });
                    updateLicenseForm(index, "erroFilial", false);
                  }}
                  options={filiaisOptions}
                  hasError={form.erroFilial}
                  errorInfo={""}
                  floatingValue={form.filial.label}
                />

                <SignatureTypeCards
                  value={form.selectedMetod}
                  onChange={(type) => {
                    updateLicenseForm(index, "selectedMetod", type);
                    updateLicenseForm(index, "erroMetodo", false);
                    if (type === "E") {
                      updateLicenseForm(
                        index,
                        "assinaturaEletronica",
                        form.assinaturaEletronica || assinaturaEletronicaPadrao || assinaturaEletronica || ""
                      );
                    }
                    if (type === "D") {
                      updateLicenseForm(
                        index,
                        "certificadoDigital",
                        form.certificadoDigital || assinaturaDigitalPadrao || null
                      );
                      updateLicenseForm(
                        index,
                        "certificadoDigitalNome",
                        form.certificadoDigitalNome ||
                          (assinaturaDigitalPadrao
                            ? assinaturaDigitalNomePadrao || "certificado_digital.pfx"
                            : "")
                      );
                    }
                  }}
                  allowedSignatures={form.allowedSignatures}
                  estadoValue={form.estadoLicenca?.value || form.estadoLicenca}
                  hasElectronicCredential={!!(
                    form.assinaturaEletronica || assinaturaEletronicaPadrao || assinaturaEletronica
                  )}
                  hasDigitalCredential={!!(
                    form.certificadoDigital ||
                    (typeof assinaturaDigitalPadrao === "string" && assinaturaDigitalPadrao.startsWith("data:"))
                  )}
                  namePrefix={`card_radio_assinatura_${index}`}
                  responsavelNome={nome}
                />

                {form.selectedMetod === "D" ? (
                  <div
                    style={{
                       width: "100%",
                      marginTop: "20px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <label
                      style={{
                        paddingLeft: "15px",
                        textAlign: "left",
                        fontSize: "12px",
                        fontWeight: 700,
                        color: "#8a92a2",
                      }}
                    >
                      Upload certificado digital
                    </label>
                    <div className="input-wrapper">
                      <div className="arquivos">
                        <label className="btn-update" htmlFor={`input-file-${index}`} onClick={() => { setRenderInput(true); }}>
                          <IconUploads
                            width="auto"
                            height="40px"
                            marginBottom="100px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                          />
                          Selecione o arquivo PFX em seu computador.<br></br><br></br>O upload do certificado é necessário caso deseje assinar sua receita digitalmente.
                          <label className="arq-name">
                            {form.certificadoDigitalNome ? (
                              <>
                                {form.certificadoDigitalNome}
                                <img
                                  src={mais}
                                  width="20"
                                  height="20"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    deleteFile(index);
                                  }}
                                />
                              </>
                            ) : (
                              "Nenhum arquivo selecionado"
                            )}
                          </label>
                        </label>
                      </div>

                      {renderInput ? (
                        <input
                          style={{ display: "none" }}
                          type="file"
                          id={`input-file-${index}`}
                          name={`file-${index}`}
                          multiple
                          onChange={(e) => onChangeCertificate(e, index)}
                        />
                      ) : null}
                    </div>
                  </div>
                ) : form.selectedMetod === "E" ? (
                  <div
                    style={{
                      width: "100%",
                      marginTop: "32px",
                    }}
                  >
                    <InputSign
                      sign={form.assinaturaEletronica}
                      update={(value) => {
                        updateLicenseForm(index, "assinaturaEletronica", value);
                      }}
                    />
                  </div>
                ) : null}

                <div
                  className="button-finish"
                  style={{
                    width: "100%",
                    padding: "0 15px",
                  }}
                >
                  <Button
                    width="100%"
                    height="50px"
                    value="Salvar CREA/CFTA/VISTO"
                    outline={false}
                    disabled={false}
                    onClick={() => handleCreateAgronomistAndCrea(null, index)}
                    loading={assinaturaLoading || creaLoading}
                  />
                </div>
              </S.ContainerCpntentAcordionCard>
            </AcordionCard>
          ))}

          <S.Button
            onClick={() => {
              setLicenseForms([
                ...licenseForms,
                {
                  id: Date.now(),
                  licenca: "",
                  estadoLicenca: "",
                  numeroLicenca: "",
                  filial: filiaisOptions.length === 1 ? filiaisOptions[0] : "",
                  selectedMetod: assinaturaDigitalPadrao
                    ? "D"
                    : assinaturaEletronicaPadrao
                    ? "E"
                    : "M",
                  receitaInicial: "",
                  assinaturaEletronica: assinaturaEletronicaPadrao || "",
                  certificadoDigital: assinaturaDigitalPadrao || null,
                  certificadoDigitalNome: assinaturaDigitalPadrao
                    ? assinaturaDigitalNomePadrao || "certificado_digital.pfx"
                    : "",
                  allowedSignatures: ['M', 'D', 'E'],
                  erroLicenca: false,
                  erroEstado: false,
                  erroNumeroLicenca: false,
                  erroFilial: false,
                  erroMetodo: false,
                  isOpen: true,
                },
              ]);
            }}
          >
            <img src={plus} alt="Adicionar" />

            <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800}>
              cadastrar nova Licença
            </TaglineM>
          </S.Button>
        </S.Wrapper>
      </S.Container>

      <ModalAlert
        show={showDisabledCad}
        onHide={() => window.location.href = "/agronomos"}
        size="md"
      >
        <h4
          style={{
            fontSize: "16px",
            textAlign: "center",
          }}
        >
          {planoSemLicencas ? "Não disponível para o seu plano" : "Limite de cadastros atingido!"}
        </h4>

        <p
          style={{
            textAlign: "center",
            marginTop: "20px",
            fontSize: "13px",
            letterSpacing: "0px",
          }}
        >
          {planoSemLicencas
            ? "O seu plano não permite adicionar mais responsáveis técnicos. Faça um upgrade para os planos Light ou Pro e inclua mais usuários."
            : "Adquira mais licenças para adicionar novos responsáveis técnicos!"}
        </p>

        <div
          className="button-finish"
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: "40px",
          }}
        >
          <Button
            width="296px"
            height="50px"
            value={planoSemLicencas ? "ATUALIZAR PLANO" : "ADQUIRIR MAIS LICENÇAS"}
            outline={false}
            disabled={false}
            onClick={() => (window.location = planoSemLicencas ? "/planos" : "/plano/edit")}
            loading={false}
          />
        </div>
      </ModalAlert>

      <ModalPassword
                text={"Precisamos da sua senha para validar a autenticidade do certificado. Para sua segurança, essa senha não ficará salva em nossos servidores."}
                show={showModal}
                update={(e) => updatePassword(e)}
                onHide={closeModalPassword}
            />
            <ModalText
                show={showModalText}
                onHide={() => setShowModalText(false)}
                text={"Certificado digital é um arquivo eletrônico que serve como identidade virtual para uma pessoa física ou jurídica. Ele serve para agilizar a assinatura conferindo legitimidade aos documentos digitais, que passam a possuir validade jurídica. Esse certificado deve ser emitido por uma Autoridade Certificadora vinculada ao ICP-Brasil"}
                btnOk={false}
            />

            <ModalAlert
                show={showModalBlock}
                onHide={false}
            >
                <h4 style={{
                    textAlign: 'center'
                }}>Essa é uma função exclusiva para clientes AgroReceita</h4>

                <p style={{
                    textAlign: 'center',
                    marginTop: '20px',
                }}>
                    Para não comprometer o controle de suas receitas agronômicas essa função só pode ser utilizada nos planos Light e Pro. Entre em contato com nosso suporte e faça o upgrade do seu plano para desbloquear esse recurso.
                </p>

                <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px' }}>
                    <Button
                        width='296px'
                        height='50px'
                        value='ENTENDI'
                        outline={false}
                        disabled={false}
                        onClick={() => setShowModalBlock(false)}
                        loading={false}
                    />
                </div>
            </ModalAlert>
    </>
  );
};
export default withRouter(AddAgronomosV2);
